import numeral from 'numeral'
import timezones from 'timezones-list'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export { default as deepClone } from 'just-clone'
export { default as get } from 'just-safe-get'
export { default as set } from 'just-safe-set'

export const isFalsy = value => {
  if (value && Array.isArray(value)) return !value.length
  if (value && typeof value === 'object') return !Object.keys(value).length
  if (typeof value === 'boolean') return false
  return !value
}

export const formatAmount = (val, format = '0,0.00') => {
  return numeral(val).format(format)
}

export const formatDate = (
  date,
  formatTo = 'DD.MM.YYYY HH:ss',
  tz = null,
  formatFrom
) => {
  return tz
    ? dayjs(date, formatFrom).tz(tz).format(formatTo)
    : dayjs(date, formatFrom).format(formatTo)
}

export const smartDateFormat = (val, omitDay = false, utc = false) => {
  const date = !utc ? dayjs(val) : dayjs.utc(val)
  const today = !utc ? dayjs() : dayjs.utc()
  if (omitDay) {
    return today.isSame(date, 'year') ? date.format('MMM') : date.format("MMM 'YY")
  } else {
    return today.isSame(date, 'year') ? date.format('DD MMM') : date.format("DD MMM 'YY")
  }
}

// remove '__typename' recursively
export const clearTypeNames = obj => {
  if (obj === null || obj === undefined) return
  if (obj.__typename !== undefined) {
    delete obj.__typename
  }
  for (const field in obj) {
    if (obj[field] === null) return
    if (typeof obj[field] === 'object') {
      clearTypeNames(obj[field])
    }
    if (Array.isArray(obj[field])) {
      obj[field].forEach(child => {
        if (typeof child === 'object') {
          clearTypeNames(child)
        }
      })
    }
  }
}

export const getUserTimeFromTime = value => {
  if (value) {
    const times = value.split(':')
    times.pop()
    return times.join(':')
  } else {
    return value
  }
}

export const getUtcOffsetTimeZone = (...args) => {
  const [tz] = args
  if (!tz || typeof tz !== 'string') return 10
  return (
    Number(timezones.find(timezone => timezone?.tzCode === tz)?.utc.slice(1, 3)) || 10
  )
}

export const errorOfEventsHandler = async (...args) => {
  const [ctx, error, to] = args

  if (error.message !== 'Удаление невозможно. У события есть резервации') {
    await ctx.$router.push(to)
  } else {
    ctx.$errorMsg(error.message)
  }
}

// searching for an object in an array of objects
// args: arr - array of objects, obj - object, notComparable - non-comparison fields
export const isEquals = (...args) => {
  const [arr, obj, notComparable] = args

  const isDate = val => {
    if (typeof val === 'string') {
      return dayjs(val).isValid()
    }
    return false
  }

  if (!obj || !arr) return false
  if (!(typeof obj !== 'object' || Array.isArray(arr))) return false
  if (notComparable && !Array.isArray(notComparable)) {
    throw new Error('non-comparables must be passed as an array!')
  }

  const searchElem = arr.find(el => el?.id === obj?.id)
  if (!searchElem) return false

  for (const key in searchElem) {
    if (!Array.isArray(searchElem[key]) && typeof searchElem[key] !== 'object') {
      if (!notComparable?.includes(key)) {
        if (isDate(obj[key]) && isDate(searchElem[key])) {
          if (
            dayjs(obj[key]).startOf('day').utc(true).format() !==
            dayjs(searchElem[key]).startOf('day').utc(true).format()
          ) {
            return false
          }
        } else if (obj[key] !== searchElem[key]) {
          return false
        }
      }
    } else if (typeof searchElem[key] === 'object' && !Array.isArray(searchElem[key])) {
      if (!notComparable?.includes(key)) {
        for (const _key in searchElem[key]) {
          if (Object.hasOwn(obj, key) && Object.hasOwn(searchElem, key)) {
            if (obj[key][_key] !== searchElem[key][_key]) {
              return false
            }
          }
        }
      }
    } else if (Array.isArray(searchElem[key])) {
      for (const _key in searchElem[key]) {
        if (
          JSON.stringify(Object.entries(searchElem[key][_key]).sort()) !==
          JSON.stringify(Object.entries(obj[key][_key]).sort())
        ) {
          return false
        }
      }
    }
  }
  return true
}

export const invalidField = (...args) => {
  const [v] = args

  if (!v) return null
  if (typeof v !== 'object') throw new Error('$v in undefined')

  const keys = Object.keys(v)
  if (!keys?.length || (keys.length === 1 && keys[0] === 'fields')) return null

  const validationFields = keys.filter(e => !e.includes('$'))
  return validationFields.find(field => v[field].$invalid) || null
}
